import template from './riskInsuranceProduct.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    product: '<',
    products: '<',
    contacts: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia, helperService, dateTimeService) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.organizationCountry = null;
      ctrl.currentDateFormat = null;
      ctrl.currentCurrency = null;
      ctrl.availablePaymentFrequencies = [];
      ctrl.availableYesNoOptionsOne = [];
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.availablePaymentFrequencies = helperService.getAvailablePaymentFrequencies({
          isExpense: false
        });
        ctrl.availableYesNoOptionsOne = helperService.getAvailableYesNoOptions({
          option: 1
        });
        ctrl.product = ctrl.product || {};
        ctrl.products = ctrl.products || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        dateTimeService.getSet(ctrl, ctrl.product, 'renewalDate', 'getSetRenewalDate');
        ctrl.isReady = true;
      };

      ctrl.saveRiskInsuranceProduct = () => {
        ctrl.onFinished({ product: ctrl.product });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
